import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  // For now, we'll just check if user is logged in
  // You can expand this to check roles, permissions, etc.
  const isAuthenticated = localStorage.getItem('isAdmin') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Add role checking logic here if needed
  if (requiredRole && requiredRole === 'admin') {
    const userRole = localStorage.getItem('userRole');
    if (userRole !== 'admin') {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;